import { Component, inject, Inject } from '@angular/core';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { IImportDialogErrors, IParkerImportErrors } from 'src/app/shared/interfaces';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-dialog-parker-import-errors',
  templateUrl: './dialog-parker-import-errors.component.html',
  styleUrl: './dialog-parker-import-errors.component.scss',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatDialogModule,
  ],
})
export class DialogParkerImportErrorsComponent {
  errorMessage: any = [];
  errorList: IParkerImportErrors[];
  appGeneralState = inject(AppGeneralStateService);

  constructor(
    public _dialogRef: MatDialogRef<DialogParkerImportErrorsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IRowNumber,
  ) {
    let tempErrorList: IParkerImportErrors[];
    tempErrorList = this.appGeneralState.importValidationErrors;
    this.errorList = tempErrorList.filter((arr) => arr.rowNumber == data.errorRowNumber);
  }
}

export interface IRowNumber {
  errorRowNumber: number;
}
